import {
    GET_ALL_GUIDE,
    GET_SPECIFIC_GUIDE
} from '@/redux/actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    guide: [],
    currentGuide: [],
    pagination: {
        current: 1,
        total: 0, // total records
        defaultPageSize: 20
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_ALL_GUIDE: {
            return {
                ...state,
                guide: action.payload?.data || [],
                pagination: {
                    current: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    defaultPageSize: parseInt(action.payload.per_page),
                }
            }
        }
        case GET_SPECIFIC_GUIDE:
            return {
                ...state,
                currentGuide: action.payload
            };
        default: return { ...state };
    }
}
